import { produce } from 'immer'
import { NavigationState } from './NavigationState'
import { NavigationType } from './NavigationType'
import { GlobalType } from '../Global'
import { CalculCodeStateKeys } from '@batical/types/src'
export const initialNavigationState: NavigationState = {
  calculLink: {}
}

export const navigationReducer = (state = initialNavigationState, action: Action) =>
  produce(state, draft => {
    switch (action.type) {
      case NavigationType.ADD_CALCUL_LINK:
        draft.calculLink[action.payload.fromKey] = {
          fromCalculCode: action.payload.fromCalculCode,
          toCalculCode: action.payload.toCalculCode
        }

        return
      case NavigationType.REMOVE_CALCUL_LINK:
        delete draft.calculLink[action.payload.fromKey]
        return
      case NavigationType.CLEAR_CALCUL_LINK:
      case GlobalType.CLEAR_LOADED_DATA:
        return { ...initialNavigationState }
    }
  })

type Action =
  | { type: GlobalType.CLEAR_LOADED_DATA }
  | {
      type: NavigationType.ADD_CALCUL_LINK
      payload: { fromKey: string; fromCalculCode: CalculCodeStateKeys; toCalculCode: CalculCodeStateKeys }
    }
  | { type: NavigationType.REMOVE_CALCUL_LINK; payload: { fromKey: string } }
  | { type: NavigationType.CLEAR_CALCUL_LINK }
